import { render, staticRenderFns } from "./Tokenomics.vue?vue&type=template&id=d510a370"
import script from "./Tokenomics.vue?vue&type=script&lang=js"
export * from "./Tokenomics.vue?vue&type=script&lang=js"
import style0 from "./Tokenomics.vue?vue&type=style&index=0&id=d510a370&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports